<template>
  <section class="section-my-profile">
    <Loader :visible="loading" />
    <div class="container">
      <div class="row">
        <div class="col-lg-2">
        </div>
        <div class="col-lg-8">
          <div align="center">
            <div class="profile-avatar">
              <img :src="user.avatar_url"/>
            </div>
            <h3 class="title">
              {{user.name}}
            </h3>
            <div class="row">
              <div class="col-12 align-center">
                <router-link class="button-favorites" :to="{name: 'MyFavorites'}">
                  {{$t("profile.myFavorites")}}
                </router-link>
              </div>
              <div class="col-12 align-center">
                <router-link class="button-favorites" :to="{name: 'MyData'}">
                  {{$t("profile.updateData")}}
                </router-link>
              </div>
            </div>
            <hr />

            <MyAlbums />
            <hr />
            <MyOrders v-if="user.id" :user-id="user.id" />

          </div>
        </div>
        <div class="col-lg-2"></div>
      </div>
    </div>
  </section>
</template>

<script>
import User from "../../models/User";
import MyAlbums from "./MyAlbums.vue";
import MyOrders from "./MyOrders.vue";
import Loader from "../../components/Loader";

export default {
  name: "Profile",
  data(){
    return{
      user: new User(),
      loading: true,
    }
  },
  components: {
    Loader,
    MyAlbums,
    MyOrders
  },
  mounted() {
    this.$user.fetch().then((request) => {
      this.$user = new User(request.response.data.user)
      this.user = this.$user
      this.loaded = true
      this.loading = false
      this.$root.$emit('setUser', this.user)
    }).catch((error) => {
      this.loaded = true
    })
  },
  methods: {},
}
</script>

<style lang="scss">
  @import '../../scss/variables.scss';

  .section-my-profile {
    margin-top: 10px;
    margin-bottom: 80px;

    .title {
      margin-top: 20px;
      margin-bottom: 20px;
      font-family: $font-bold;
      font-style: normal;
      font-weight: 800;
      font-size: 26px;
      line-height: 34px;
      text-align: center;
      color: #000000;
    }
  }

  .profile-avatar {
    width: 100px;
    cursor: pointer;
    height: 100px;
    line-height: 100px;
    border-radius: 50%;
    font-size: 50px;
    text-align: center;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .button-favorites {
    margin-top: 5px;
    padding: 15px 10px 15px 10px;
    background: $primary-base !important;
    border: 1px solid $primary-base !important;
    color: white;
    border-radius: 25px;
    width: 280px;
    font-family: $font-bold;
    text-decoration: none;
    display: inline-block;

    &:hover {
      color: white;
    }
  }
</style>
